function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.8119 0L12.5208 4.26106C11.4522 5.33049 11.4522 7.10393 12.5208 8.17522L10.8697 9.79468L9.68234 8.60745L2.7253 1.651L2.05743 1.01286L1.38955 1.65007C0.600825 2.444 0.158162 3.51764 0.158162 4.6367C0.158162 5.75577 0.600825 6.82941 1.38955 7.62334L7.21676 13.4482L0 20.6644L1.33297 22L8.54973 14.782L9.65173 15.8542L10.3177 16.5202L10.9559 15.8542L12.6071 14.2014L20.4054 21.9991L21.7412 20.6634L13.2759 12.2294L12.2026 11.1303L13.8259 9.47932H13.8556L13.8835 9.50715C14.9576 10.5274 16.6848 10.5321 17.7386 9.47932L17.8258 9.36245L22 5.18858L20.6958 3.88448L16.4353 8.14368C16.0318 8.54808 15.5661 8.55643 15.1598 8.17429L20.0576 3.24634L18.7543 1.94224L13.8259 6.83958C13.4438 6.43425 13.4521 5.96771 13.8556 5.56516L18.1161 1.3041L16.8119 0ZM2.31716 3.91416L11.3056 12.8982L10.3187 13.8841L2.72437 6.2877C2.03609 5.60133 2.01568 4.73317 2.31623 3.91323L2.31716 3.91416Z",
  fill: "#20205D"
});

var SvgMenu = function SvgMenu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu.b29511d9.svg";
export { ForwardRef as ReactComponent };